import { render, staticRenderFns } from "./ModalPaymentWallet.vue?vue&type=template&id=8e1f2a4a&"
import script from "./ModalPaymentWallet.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports